/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from "react";
import { InlineEdit } from "../../components/InlineEdit";
import { Button } from "../../components/Button";
import { useParams } from "react-router-dom";
import useSaveTemplate from "../../utils/customHooks";
import { SpinnerOverlay } from "../../utils/SpinnerOverlay";

// WZ127 — KD463002WHITE 190x253
// Pozycje tekstów (style inline, w mm):
//   top   = górna krawędź pola tekstowego
//   left  = środek tekstu (textAlign center + translateX(-50%)) albo lewa krawędź (textAlign left)
//   right = prawa krawędź pola (textAlign right)
// maxWidthN = maks. szerokość tekstu w px — dłuższy tekst zmniejsza czcionkę.
// Uwaga: lineHeight w stylu InlineEdit nie działa (nadpisuje go `font: inherit`), zawsze wynosi 1.5.
export const Wz127: React.FC = () => {
  const { pdfNameFromUrl } = useParams<{ pdfNameFromUrl: string }>();
  const [text1, setText1] = useState<string>("Kacperek");
  const [text2, setText2] = useState<string>("ur. 12.08.2024");
  const [text3, setText3] = useState<string>("3500g szczęścia");
  const [text4, setText4] = useState<string>("54 cm radości");
  const text1BasicSize = 123;
  const text2BasicSize = 55;
  const text3BasicSize = 34;
  const text4BasicSize = 34;
  const [fontSizeText1, setFontSizeText1] = useState<number>(text1BasicSize);
  const [fontSizeText2, setFontSizeText2] = useState<number>(text2BasicSize);
  const [fontSizeText3, setFontSizeText3] = useState<number>(text3BasicSize);
  const [fontSizeText4, setFontSizeText4] = useState<number>(text4BasicSize);
  const { saveTemplate, isSaving } = useSaveTemplate();

  const pdfWidth = "190mm"; // PDF width in mm
  const pdfHeight = "253mm"; // PDF height in mm
  const font1 = "CookieRegular";
  const maxWidth1 = 495;
  const maxWidth2 = 363;
  const maxWidth3 = 237;
  const maxWidth4 = 214;

  const adjustFontSize = (
    text: string,
    currentFontSize: number,
    maxFontSize: number,
    minFontSize: number,
    fontFamily: string,
    maxWidth: number
  ) => {
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");

    if (context) {
      let newFontSize = currentFontSize;
      context.font = `${newFontSize}px ${fontFamily}`;
      let textWidth = context.measureText(text).width;

      while (textWidth > maxWidth && newFontSize > minFontSize) {
        newFontSize -= 1;
        context.font = `${newFontSize}px ${fontFamily}`;
        textWidth = context.measureText(text).width;
      }

      while (textWidth < maxWidth * 0.9 && newFontSize < maxFontSize) {
        newFontSize += 1;
        context.font = `${newFontSize}px ${fontFamily}`;
        textWidth = context.measureText(text).width;
      }

      return newFontSize;
    }

    return currentFontSize;
  };

  // Czekamy na załadowanie fontu, inaczej canvas mierzy tekst fontem zastępczym.
  const ensureFont = (fontFamily: string) => document.fonts.load(`1em ${fontFamily}`);

  useEffect(() => {
    ensureFont(font1).then(() =>
      setFontSizeText1(adjustFontSize(text1, fontSizeText1, text1BasicSize, 14, font1, maxWidth1))
    );
  }, [text1]);
  useEffect(() => {
    ensureFont(font1).then(() =>
      setFontSizeText2(adjustFontSize(text2, fontSizeText2, text2BasicSize, 14, font1, maxWidth2))
    );
  }, [text2]);
  useEffect(() => {
    ensureFont(font1).then(() =>
      setFontSizeText3(adjustFontSize(text3, fontSizeText3, text3BasicSize, 10, font1, maxWidth3))
    );
  }, [text3]);
  useEffect(() => {
    ensureFont(font1).then(() =>
      setFontSizeText4(adjustFontSize(text4, fontSizeText4, text4BasicSize, 10, font1, maxWidth4))
    );
  }, [text4]);

  const handleSave = () => {
    saveTemplate(
      "printable-content",
      {
        pdfWidth: pdfWidth,
        pdfHeight: pdfHeight,
        pdfNameFromUrl: pdfNameFromUrl,
      },
      null,
      false
    );
  };

  return (
    <div style={{
      width: "100%",
      height: "100%",
      backgroundColor: "#ffffff", padding: "60px",
      position: "relative",
    }}>
      {/* Spinner Overlay */}
      <SpinnerOverlay isVisible={isSaving} />
      <div style={{ position: "absolute", top: "10px", left: "0px", right: "0px", margin: "auto", color: "white", width: "150px", height: "50px" }}>
        <Button onClick={handleSave} disabled={isSaving}>
          {isSaving ? "Zapisywanie..." : "Zapisz"}
        </Button>
      </div>

      <div
        id="printable-content"
        style={{
          position: "relative",
          width: pdfWidth,
          height: pdfHeight,
          fontFamily: "CookieRegular",
          backgroundColor: "#ffffff",
          margin: "auto",
        }}
      >
        {/* Kacperek */}
        <InlineEdit
          value={text1}
          setValue={setText1}
          style={{
            fontSize: `${fontSizeText1}px`,
            fontFamily: font1,
            color: "#938972",
            position: "absolute",
            top: "30.7mm",
            left: "94.4mm",
            width: `${maxWidth1 + 10}px`,
            transform: "translateX(-50%)",
            textAlign: "center",
            paddingLeft: "5px",
            letterSpacing: "0.2px",
            fontWeight: "400",
            zIndex: "12",
          }}
        />
        {/* ur. 12.08.2024 */}
        <InlineEdit
          value={text2}
          setValue={setText2}
          style={{
            fontSize: `${fontSizeText2}px`,
            fontFamily: font1,
            color: "#938972",
            position: "absolute",
            top: "196.8mm",
            left: "95.4mm",
            width: `${maxWidth2 + 10}px`,
            transform: "translateX(-50%)",
            textAlign: "center",
            paddingLeft: "5px",
            fontWeight: "400",
            zIndex: "12",
          }}
        />
        {/* 3500g szczęścia */}
        <InlineEdit
          value={text3}
          setValue={setText3}
          style={{
            fontSize: `${fontSizeText3}px`,
            fontFamily: font1,
            color: "#938972",
            position: "absolute",
            top: "217.6mm",
            left: "94.7mm",
            width: `${maxWidth3 + 10}px`,
            transform: "translateX(-50%)",
            textAlign: "center",
            paddingLeft: "5px",
            fontWeight: "400",
            zIndex: "12",
          }}
        />
        {/* 54 cm radości */}
        <InlineEdit
          value={text4}
          setValue={setText4}
          style={{
            fontSize: `${fontSizeText4}px`,
            fontFamily: font1,
            color: "#938972",
            position: "absolute",
            top: "227.4mm",
            left: "94.8mm",
            width: `${maxWidth4 + 10}px`,
            transform: "translateX(-50%)",
            textAlign: "center",
            paddingLeft: "5px",
            fontWeight: "400",
            zIndex: "12",
          }}
        />

        <img
          src="/images/KD463002_WZ127.svg"
          alt=""
          style={{ width: "100%", height: "100%", position: 'absolute', top: '0', left: '0', zIndex: '2' }}
        />
      </div>
    </div>
  );
};
